<div class="card">
  <div class="card-body pt-0 pb-0">
    <div class="d-md-flex align-items-center bg-white px-3">
      <div class="ml-auto mt-3 mt-md-0">
        <button type="button" class="btn btn-cyan py-2" (click)='add()'><i
          class="fas fa-plus  font-14 mr-1 text-white"></i>
          
          <span class="ml-1 text-white font-weight-bold">Aggiungi</span>
        </button>
        <button *ngIf="environment.ClientiAddOn['importReferenti']" class="btn btn-white rounded-pill py-2" (click)='Import()'><i
          class="fas fa-upload  font-14 mr-1 text-info"></i>
          <span class="ml-1 text-info ">Importa</span>
        </button>
        <button *ngIf="SelectedRef()?.length>0 && environment.ClientiAddOn['InvioCredReferenti']" class="btn btn-white rounded-pill py-2" (click)='InviaCred()'><i
          class="fas fa-upload  font-14 mr-1 text-info"></i>
          <span class="ml-1 text-info ">Invia Credenziali</span>
        </button>
      </div>
    </div>
  </div>
</div>
<div class="card pt-0">
  <div class="card-body pt-0">
    <div class="table-responsive" style="overflow: visible;" >
      <table class="table bg-white table-hover align-middle mb-0 no-wrap">
        <thead>
        <tr>
          <th scope="col"  *ngIf=" environment.ClientiAddOn['InvioCredReferenti']" class="align-middle" >
            <input type="checkbox" *ngIf=" environment.ClientiAddOn['InvioCredReferenti']" [(ngModel)]="SelectAll" name="list_name" value="h1" (change)="checkUncheckAll()" />
          </th>
          <th scope="col">{{'cliente.nome' | translate}}</th>
          <th scope="col">{{'cliente.cognome' | translate}}</th>
          <th scope="col" *ngIf="environment.ClientiAddOn['indirizzoReferente']">{{'cliente.indirizzo' | translate}}</th>
          <th scope="col">{{'cliente.telefono' | translate}}</th>
          <th scope="col">{{'cliente.email' | translate}}</th>
          <!--<th scope="col">{{'cliente.ruolo' | translate}}</th>-->
          <th scope="col" *ngIf="environment.ClientiAddOn['repartoReferente']">{{'cliente.reparto' | translate}}</th>
          <th scope="col">{{'cliente.Actions' | translate}}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of Lista" >
          <td *ngIf=" environment.ClientiAddOn['InvioCredReferenti']" class="align-middle"  >
            <input type="checkbox" [(ngModel)]="item.isSelected" name="list_name"
                   (change)="isAllSelected()" />
          </td>
          <td class="align-middle" >
            <span *ngIf="!item.InModifica">
              {{ item.nome }}
            </span>
            <span *ngIf="item.InModifica">
              <input [(ngModel)]="item.nome" placeholder="{{'cliente.nome' | translate}}" type="text" name="nome" class="form-control">
            </span>
          </td>
          <td class="align-middle" >
            <span *ngIf="!item.InModifica">
              {{ item.cognome }}
            </span>
            <span *ngIf="item.InModifica">
              <input [(ngModel)]="item.cognome" placeholder="{{'cliente.cognome' | translate}}" type="text" name="nome" class="form-control">
            </span>
          </td>
          <td class="align-middle" *ngIf="environment.ClientiAddOn['indirizzoReferente']">
            <span *ngIf="!item.InModifica">
              {{ item.indirizzo }}
            </span>
            <span *ngIf="item.InModifica">
              <input [(ngModel)]="item.indirizzo" placeholder="{{'cliente.indirizzo' | translate}}" type="text" name="nome" class="form-control">
            </span>
          </td>
          <td class="align-middle" >
            <span *ngIf="!item.InModifica">
              {{ item.telefono }}
            </span>
            <span *ngIf="item.InModifica">
              <input [(ngModel)]="item.telefono" placeholder="{{'cliente.telefono' | translate}}" type="text" name="nome" class="form-control">
            </span>
          </td>
          <td class="align-middle" >
            <span *ngIf="!item.InModifica">
              {{ item.email }}
            </span>
            <span *ngIf="item.InModifica">
              <input [(ngModel)]="item.email" placeholder="{{'cliente.email' | translate}}" type="text" name="nome" class="form-control">
            </span>
          </td>
          <td class="align-middle" style="    min-width: 250px;" *ngIf="environment.ClientiAddOn['repartoReferente']">
            <span *ngIf="!item.InModifica">
              {{ item.repartoObject?.label }}
            </span>
            <span *ngIf="item.InModifica" style="min-width: 200px">
                    <ng-multiselect-dropdown [settings]="dropSetting" [placeholder]="'Seleziona'" [data]="reparti" [(ngModel)]="item.repartoObject">
                    </ng-multiselect-dropdown>
            </span>
          </td>
         <!-- <td class="align-middle" >
            <span *ngIf="!item.InModifica">
              {{ item.note }}
            </span>
            <span *ngIf="item.InModifica">
              <input [(ngModel)]="item.note" placeholder="{{'cliente.ruolo' | translate}}" type="text" name="nome" class="form-control">
            </span>
          </td>-->
          <td class="align-middle" >
            <a href="javascript:void(0)" [ngbTooltip]="item.InModifica? translate.instant('cliente.save'): translate.instant('cliente.edit')" class="link font-16 text-success font-medium mr-2" (click)='edit(item)'>
              <i-feather [name]="!item.InModifica? 'edit-3': 'check'" class="feather-sm"></i-feather>
            </a>
            <a href="javascript:void(0)" [ngbTooltip]="item.InModifica? translate.instant('cliente.cancel'): translate.instant('cliente.delete')"
               class="link font-16 text-danger font-weight-bold" (click)='delete(item)'>
              <i *ngIf="item.InModifica" class="fas fas fa-times"></i>
              <i-feather *ngIf="!item.InModifica" name="trash-2" class="feather-sm"></i-feather>
            </a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

